var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3086 4.61328C12.6419 5.53995 13.5619 7.01328 13.7486 8.71328",
    stroke: "#6F00FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.32422 8.74673C2.49755 7.0534 3.40422 5.58006 4.72422 4.64673",
    stroke: "#6F00FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.46094 14.46C6.23427 14.8533 7.11427 15.0733 8.04094 15.0733C8.93427 15.0733 9.77427 14.8733 10.5276 14.5066",
    stroke: "#6F00FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.04083 5.63318C9.0644 5.63318 9.89417 4.80341 9.89417 3.77985C9.89417 2.75628 9.0644 1.92651 8.04083 1.92651C7.01727 1.92651 6.1875 2.75628 6.1875 3.77985C6.1875 4.80341 7.01727 5.63318 8.04083 5.63318Z",
    stroke: "#6F00FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.22052 13.7802C4.24409 13.7802 5.07385 12.9504 5.07385 11.9268C5.07385 10.9033 4.24409 10.0735 3.22052 10.0735C2.19695 10.0735 1.36719 10.9033 1.36719 11.9268C1.36719 12.9504 2.19695 13.7802 3.22052 13.7802Z",
    stroke: "#6F00FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7791 13.7802C13.8027 13.7802 14.6324 12.9504 14.6324 11.9268C14.6324 10.9033 13.8027 10.0735 12.7791 10.0735C11.7555 10.0735 10.9258 10.9033 10.9258 11.9268C10.9258 12.9504 11.7555 13.7802 12.7791 13.7802Z",
    stroke: "#6F00FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.938de07fccaef6af978bae4c4923f859.svg";
export { ForwardRef as ReactComponent };